
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 26 18"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"12.759","cy":"14.961","r":"2.146","fill":"#77E6E0"}}),_c('path',{attrs:{"fill":"#77E6E0","d":"M8.624 5.874a10.7 10.7 0 0 1 3.99-.829c1.367-.017 2.72.23 3.98.728l-2.699 6.345a3.5 3.5 0 0 0-1.32-.24c-.454.005-.904.098-1.324.274z"}}),_c('path',{attrs:{"stroke":"#234652","stroke-width":"1.38","d":"M12.447 6.428v7.723"}}),_c('circle',{attrs:{"cx":"12.286","cy":"14.96","r":"1.454","stroke":"#234652","stroke-width":"1.38","transform":"rotate(-90 12.286 14.96)"}}),_c('path',{attrs:{"stroke":"#234652","stroke-width":"1.38","d":"M.708 14.961C.708 8.45 5.988 3.17 12.5 3.17c6.513 0 11.793 5.28 11.793 11.792"}})])
          )
        }
      }
    